module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"PropTypes","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types","umd":"prop-types"}
// module id = 5
// module chunks = 0